import React from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';


import { makeStyles, ThemeProvider } from '@material-ui/styles';

import './datepicker.scss';
import { formLabelsTheme } from '../../style_jsx/styles';
import useTranslateText from '../use_translate_text';
import { GridItem } from '@patternfly/react-core';
import { Box, InputAdornment, InputLabel } from '@material-ui/core';

/*const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#3e6b7b',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161',
};

const materialTheme = createTheme({
  palette: {
    primary: grey,
  },
});*/


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
    '&$checked': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
  },
  input: {
    height: 40,
    [theme.breakpoints.up('300')]: {
      width: 160,
    },
    [theme.breakpoints.up('576')]: {
      width: 200,
    },
    [theme.breakpoints.up('768')]: {
      width: 170,
    },
    [theme.breakpoints.up('1024')]: {
      width: 160,
    },
    color: '#76787A',
    fontSize: '14px',
  },
  inputLargeSize: {
    height: 40,
    [theme.breakpoints.up('300')]: {
      width: 240,
    },
    [theme.breakpoints.up('350')]: {
      width: 270,
    },
    [theme.breakpoints.up('375')]: {
      width: 290,
    },
    [theme.breakpoints.up('400')]: {
      width: 320,
    },
    [theme.breakpoints.up('540')]: {
      width: 450,
    },
    [theme.breakpoints.up('576')]: {
      width: '100%',
    },
    [theme.breakpoints.up('768')]: {
      width: 205,
    },
    [theme.breakpoints.up('1024')]: {
      width: 190,
    },
    color: '#76787A',
    fontSize: '14px',
  },
  datepicker: {
    'label + &': {
      marginBottom: 60,
      backgroundColor: 'red',
    },

  },
  checked: {},
}));

const helperTextStyles = makeStyles(({
  root: {
    margin: 2,
    '&$error': {
      color: 'red',
    },
  },
  error: {
    '&.MuiFormHelperText-root.Mui-error': {
      color: 'red',
    },
  },
}));

const DatePicker = (props) => {

  const { selectedDate, setSelectedDate, label, format, disableFuture, className, ...rest } = props,
        classes = `date-picker m-0 ${className}`;

  const handleDateChange = (date) => {
    // const usDate = date.toLocaleDateString(
    //   'en-US',
    //   { year: 'numeric', month: '2-digit', day: '2-digit' },
    // );
    // console.log(date);
    setSelectedDate(date);
  };
  const helperclasses = helperTextStyles();
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={formLabelsTheme}>

        <KeyboardDatePicker
          className={classes}
          disableFuture={disableFuture || false}
          margin="normal"
          // id="date-picker-dialog"
          id="outlined-basic"
          variant="outlined"
          label={label}
          format={format || 'MM/dd/yyyy'}
          value={selectedDate}
          onChange={handleDateChange}
          FormHelperTextProps={{ classes: helperclasses }}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          // invalidDateMessage = "Invalid Date"
          InputProps={{
            disableUnderline: true,
            color: '#76787A',
            endAdornment: (
              <InputAdornment position="end">
                <Box
                  onClick={() => {}}
                  className="calendarIcon"
                />
              </InputAdornment>
            ),
          }}
          // halfWidth

          {...rest}
        />
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export const Date_Picker_Wrapper = (props) => {
  const { translateText } = useTranslateText(),
        { date, setDate, disableForm, disableFuture, inputSize, labelNotRequired, error, helperText } = props,
        classes = useStyles();
  const handleDateChange = (date) => {
    setDate(date);
  };
  return (
    <GridItem className="d-flex mb-2">
      {labelNotRequired ? null : <InputLabel component="legend" className="labels w-unset mt-3">
        {`${translateText('Date')}:`}
      </InputLabel>}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={formLabelsTheme}>
          <KeyboardDatePicker
            disabled={disableForm}
            inputVariant="outlined"
            format="MM/dd/yyyy"
            margin="minimal"
            views={['year', 'month', 'date']}
            disableFuture={disableFuture === false ? false : true}
            animateYearScrolling={true}
            selectedDate={date}
            onChange={handleDateChange}
            value={date}
            setSelectedDate={(date) => setDate(date)}
            className={`${classes.datepicker} ml-3`}
            error= {error}
            helperText= {helperText}
            // KeyboardButtonProps={{
            //   'aria-label': 'change date',
            // }}
            InputProps={{
              disableUnderline: true,
              color: '#76787A',
              className: inputSize === 'custom' ? `${classes.inputLargeSize}` : `${classes.input}`,
              // style: { padding: 8 },
              endAdornment: (
                <InputAdornment position="end">
                  <Box
                    onClick={() => {}}
                    className="calendarIcon"
                  />
                </InputAdornment>
              ),
            }}
            halfWidth

            // InputAdornmentProps = {{ position: 'right' }}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </GridItem>
  );
};
export default DatePicker;